module.exports = __webpack_public_path__ + "media/machiheno.c5945140.mp3";